<form [formGroup]="form">
  <ct-control [configuration]="controlConfiguration"></ct-control>
</form>
